import { render, staticRenderFns } from "./inviteWithdrawal.vue?vue&type=template&id=4075bc16&scoped=true"
import script from "./inviteWithdrawal.vue?vue&type=script&lang=js"
export * from "./inviteWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./inviteWithdrawal.vue?vue&type=style&index=0&id=4075bc16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075bc16",
  null
  
)

export default component.exports